import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { pick } from 'ramda';
import { log } from 'log';
import { useUserSelector } from 'js/store/hooks';
import { useChangeLoginSessionLanguage } from 'server';
import { languageService } from 'js/services/language.service';
import { toggleIsChangeLangInProgress } from 'js/components/system/App/store/actions';

import { useSetLanguagePathname } from './useSetLanguagePathname';

export const useSetCurrentLanguage = () => {
    const changeLoginSessionLanguage = useChangeLoginSessionLanguage();
    const dispatch = useDispatch();
    const setLanguagePathname = useSetLanguagePathname();
    const { isLoggedIn, lang } = useUserSelector(pick(['lang', 'isLoggedIn']));

    return useCallback(async (langToSet: string): Promise<void> => {
        if (langToSet === lang) {
            return;
        }

        const languageCode = languageService.getTwoLetterLanguage(langToSet);

        if (isLoggedIn && languageCode) {
            try {
                await changeLoginSessionLanguage(languageCode);
            } catch (error) {
                log('error', error);
            }
        }

        dispatch(toggleIsChangeLangInProgress(true));
        setLanguagePathname(langToSet);
    }, [lang, isLoggedIn, setLanguagePathname, changeLoginSessionLanguage, dispatch]);
};
